import staticQueryData from "../../public/static/d/2417117884.json";

/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

function SEO(_ref) {
  var description = _ref.description,
      lang = _ref.lang,
      meta = _ref.meta,
      title = _ref.title;
  var site = staticQueryData.data.site;
  var metaDescription = description || site.siteMetadata.description;
  return React.createElement(Helmet, {
    htmlAttributes: {
      lang: lang
    },
    title: title,
    titleTemplate: "%s | " + site.siteMetadata.title,
    meta: [{
      name: "google-site-verification",
      content: "MKRfsXHCgTA_I5JNclOta5Sg_ox6UWgJW8dHVpnbhhI"
    }, {
      name: "p:domain_verify",
      content: "c1331b35372fe2490b8c28028c1c5f94"
    }, {
      name: "description",
      content: metaDescription
    }, {
      property: "og:title",
      content: title
    }, {
      property: "og:description",
      content: metaDescription
    }, {
      property: "og:type",
      content: "website"
    }, {
      name: "twitter:card",
      content: "summary"
    }, {
      name: "twitter:creator",
      content: site.siteMetadata.author
    }, {
      name: "twitter:title",
      content: title
    }, {
      name: "twitter:description",
      content: metaDescription
    }].concat(meta)
  });
}

SEO.defaultProps = {
  lang: "en",
  meta: [],
  description: "ARANHA Ag\xEAncia de publicidade"
};
SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
};
export default SEO;